import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { API_URL } from '../../constants/url.constants';
import { ResponseAndErrorModel } from 'common/models/utilitymodels/base.model';
import { environment } from 'common/environment/environment.dev';

@Injectable({
    providedIn: 'root',
})
export abstract class BaseDataService<T> {
    constructor(public API_URL: API_URL, protected httpService: HttpService) { }
    public abstract dataModel(): T;

    prefillDataModel(data: any) {
        return data;
    }

    getAPI_URL(): API_URL {
        return this.API_URL;
    }

    modifyAPI_URL(params: any): string {
        return this.getAPI_URL();
    }

    resResolveOrReject(): boolean {
        return true;
    }

    getDatafromAPI(params: any[] | any): Promise<any> {
        return new Promise((resolve, reject) => {
            const formattedParams = this.formarARNParameter(params);
            const paramUrl = formattedParams.length === 0 ? this.getAPI_URL() : this.getAPI_URL() + '/' + formattedParams.join('/');
            this.httpService
                .getData(paramUrl)
                .then((data) => {
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    formarARNParameter(params: string[]) {
        const returnParam: string[] = [];
        params.forEach((param: any) => {
            const paramStr = typeof param !== 'string' ? param?.toString() : param;
            paramStr.startsWith('ARN-') ? returnParam.push(paramStr.split('_')[0]) : returnParam.push(paramStr);
        });

        return returnParam;
    }

    listgetDatafromAPI(params: any): Promise<any> {
        return new Promise((resolve, reject) => {
            const paramUrl = this.modifyAPI_URL(params);
            this.httpService
                .getData(paramUrl)
                .then((data) => {
                    const cloneRes = JSON.parse(JSON.stringify(data));
                    resolve(this.transformSuccessData(data, params));
                })
                .catch((error: any) => {
                    if (this.resResolveOrReject()) {
                        resolve(this.transformErrorData(error, params));
                    } else {
                        reject(error);
                    }
                });
        });
    }

    transformSuccessData(data: any, params: any) {
        const res = new ResponseAndErrorModel(data, []);
        return res;
    }

    transformErrorData(error: any, params: any) {
        const res = new ResponseAndErrorModel([], [{ ...error }]);
        return res;
    }

    postDatatoAPI(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.httpService
                .postData(this.getAPI_URL(), data)
                .then((data) => {
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    deleteDatatoApi(url: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.httpService
                .deleteData(url)
                .then((data) => {
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    prepareAPIErrorMessage(data: any) {
        if (Object.keys(data).length === 1 && Object.keys(data)[0].toLowerCase() === 'error') {
            return this.API_URL.startsWith(environment.logicAPI) ? data['error']?.message : data['Error'];
        } else if (data.status && data.status === 'Failed') {
            return data.error;
        } else {
            return null;
        }
    }

    convertURLToBlob(url: string) {
        return new Promise((resolve, reject) => {
            this.httpService
                .getImage(url)
                .then((data) => {

                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}
